import { createTestListOperations } from '../../../common/test-case/operations';
import filterOperations from '../../filters/operations';
import actions from './actions';
import * as selectors from './selectors';

const operations = {};
export default Object.assign(
  operations,
  createTestListOperations({
    actions,
    selectors,
    operations,
    filterOperations,
  }));
